import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, CircularProgress } from "material-ui"
import Table from "../../components/common/Table"
import moment from "moment"
import ExternalLink from "../common/externalLink/ExternalLink"
import * as utils from "../../helpers/utils"
import strings from "../../localization/strings"
import { IStripeInvoice } from "../../models"

interface IProps {
    loadingInvoices: boolean
    invoices: IStripeInvoice[]
}

const AccountBillingInvoicesTable: React.SFC<IProps> = (props: IProps) => {
    return (
        <div className="InvoicesTable" style={{ position: "relative" }}>
            <Table items={props.invoices} unClickableCols={[0]} readonly>
                <TableHeader>
                    <TableRow>
                        <TableHeaderColumn style={{ width: 25, }} />
                        <TableHeaderColumn style={{ width: 25, }} />
                        <TableHeaderColumn >
                            {strings.Name}
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 100, }}>
                            {strings.Date}
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 100, }}>
                            {strings.DueDate}
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 100, }}>
                            {strings.Amount}
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: 50 }} >
                            {strings.Status}
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                {props.loadingInvoices ? <TableBody><TableRow><TableRowColumn style={{ textAlign: "center" }}><CircularProgress /></TableRowColumn></TableRow></TableBody> :
                    <TableBody showRowHover={true} deselectOnClickaway={false}>
                        {props.invoices.map((row, i) =>
                            <TableRow key={row.Id}>
                                <TableRowColumn data-intercom-target={i === 0 && "menu-Employees-openAccountInNewTab"} style={{ width: 25, }}>
                                    <ExternalLink
                                        url={row.HostedInvoiceUrl}
                                    />
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 25, }}>
                                    <ExternalLink
                                        url={row.InvoicePdf}
                                        className="fa fa-file-pdf-o"
                                    />
                                </TableRowColumn>
                                <TableRowColumn >
                                    {row.Lines.map((line, i) => {
                                        return (
                                            <div key={i}>
                                                <div>{utils.getCurrencyFormat(line.Amount / 100)}</div>
                                                <div>{line.Description}</div>
                                            </div>)
                                    })}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 100 }}>
                                    {moment(row.Created).format("MM/DD/YYYY")}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 100 }}>
                                    {moment(row.DueDate).format("MM/DD/YYYY")}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 100 }}>
                                    {utils.getCurrencyFormat(row.AmountDue / 100)} {row.Currency}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {row.Status}
                                </TableRowColumn>
                            </TableRow>
                        )}
                    </TableBody>
                }
            </Table>
        </div>
    )
}

export default AccountBillingInvoicesTable